/**
 * Created by zzy on 2019/8/5.
 */
import AlarmEventsModal from './AlarmEventsModal.vue'
export default AlarmEventsModal



// WEBPACK FOOTER //
// ./src/views/common/alarmEventsModal/index.js